export default __webpack_public_path__ + "static/media/04.9c1e7f57.svg";